// extracted by mini-css-extract-plugin
export default {"layout":"layout___Ch4yf","layoutInner":"layoutInner____AQxT"};